import { Dispatch } from 'redux';

import { subscribeToCmsApiSubsite } from 'modules/cms/api/cmsApiSubscribeEndpoints';

// Types

export type MainStoreSubscribedSubsitesState = {
  subsiteIds: string[];
};

type AddSubscribedSubsiteAction = {
  type: 'ADD_SUBSCRIBED_SUBSITE';
  subsiteId: string;
};

export type MainStoreSubscribedSubsitesAction = AddSubscribedSubsiteAction;

// Reducer

export function subscribedSubsitesReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: MainStoreSubscribedSubsitesState = {
    subsiteIds: [],
  },
  action: MainStoreSubscribedSubsitesAction
) {
  switch (action.type) {
    case 'ADD_SUBSCRIBED_SUBSITE': {
      const { subsiteId } = action;
      return { ...state, subsiteIds: [...state.subsiteIds, subsiteId] };
    }

    default:
      return state;
  }
}

// Actions

export const addSubscribedSubsite =
  (subsiteId: string) =>
  (dispatch: Dispatch<MainStoreSubscribedSubsitesAction>) =>
    dispatch({
      type: 'ADD_SUBSCRIBED_SUBSITE',
      subsiteId,
    });

export const subscribeToSubsite =
  (subsiteId: string) =>
  (dispatch: Dispatch<MainStoreSubscribedSubsitesAction>) =>
    subscribeToCmsApiSubsite(subsiteId).then(() => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch<any>(addSubscribedSubsite(subsiteId));
    });
